module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_part1"
    }
  }, [_vm._v("I Thought You and Me Were Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap1"
    }
  }, [_vm._v("Mr. Z")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap2"
    }
  }, [_vm._v("RG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap3"
    }
  }, [_vm._v("Chango")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_part2"
    }
  }, [_vm._v("They Say He Was Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap4"
    }
  }, [_vm._v("Domingo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap5"
    }
  }, [_vm._v("Big Jesse, Little Jesse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap6"
    }
  }, [_vm._v("Charro")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "part-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_part3"
    }
  }, [_vm._v("Don't Believe Anything He Tells You")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap7"
    }
  }, [_vm._v("Jerry Fuentes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap8"
    }
  }, [_vm._v("Yolanda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "chap-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_chap9"
    }
  }, [_vm._v("Mrs. Perez")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "ackn-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_ackn1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "afte-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Brownsville_afte1"
    }
  }, [_vm._v("A Note on the Type")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13448570","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Brownsville_toc.vue
// module id = 63
// module chunks = 0